import React from 'react';
import '../LoginPage.css';
import CostcoLogo from '../CostcoLogo';

function AuthLayout({ title, subtitle, children, footer, brand }) {
  return (
    <div className="login-page">
      <div className="login-container auth-container">
        {brand === 'costco' && (
          <div className="login-brand login-brand--costco">
            <CostcoLogo compact />
          </div>
        )}
        <div className="login-header">
          <h1>{title}</h1>
          {subtitle && <p>{subtitle}</p>}
        </div>
        {children}
        {footer && <div className="login-footer">{footer}</div>}
      </div>
    </div>
  );
}

export default AuthLayout;
